module.exports = __webpack_public_path__ + "static/media/plan-mas-gigas-libres-plus.c908b19f.svg";